import { pick } from 'ramda';

export default pick([
  'accept-charset',
  'action',
  'autocomplete',
  'enctype',
  'method',
  'post',
  'name',
  'novalidate',
  'target',
]);
